import {
  GET_SKULOOKUPNU_REPORT_REQUEST,
  GET_SKULOOKUPNU_REPORT_SUCCESS,
  GET_SKULOOKUPNU_REPORT_ERROR,
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";


export const getskuloopupnu = (token, values) => (dispatch) => {
  dispatch({ type: GET_SKULOOKUPNU_REPORT_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/Skulookupreportnu`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: values, 
  })
    .then((response) => {
      return dispatch({
        type: GET_SKULOOKUPNU_REPORT_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_SKULOOKUPNU_REPORT_ERROR,
        payload: [],
      });
      
      
      
      
      
      
      
      
      
      
    });
};
